import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconEvents = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={28}
      height={28}
      fill="none"
      viewBox="0 0 28 28"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <rect x="4" y="11" width="20" height="13" rx="1" stroke="currentColor" fill="none" strokeWidth="2" />
      <path
        d="M12.6462 20.4125L12.4199 19.9667L12.6462 20.4125L17.0863 18.159C17.3391 18.0307 17.5 17.7805 17.5 17.5C17.5 17.2195 17.3391 16.9693 17.0863 16.841L12.6462 14.5875C12.4006 14.4628 12.1272 14.4791 11.9137 14.5875C11.6997 14.6961 11.5 14.9266 11.5 15.2465L11.5 19.7535C11.5 20.0734 11.6997 20.3039 11.9137 20.4125C12.1272 20.5209 12.4006 20.5372 12.6462 20.4125Z"
        fill="none"
        stroke="currentColor"
      />
      <path d="M21 7L7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      <path d="M19 3L9 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </SvgIcon>
  );
};
